import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * 文本阅读主题选择器组件
 * 提供图标按钮和下拉面板，让用户选择适合的阅读主题
 */
import { useState, useRef, useEffect } from 'react';
const ThemeItem = ({ theme, isSelected, onClick }) => {
    return (_jsxs("button", { type: "button", className: `w-full flex items-center gap-3 px-3 py-2 text-xs text-left hover:bg-gray-100 transition-colors rounded ${isSelected ? 'bg-static-eggshell text-interactive-emerald-flash' : 'text-gray-700'}`, onClick: () => onClick(theme), children: [_jsxs("div", { className: "flex gap-1", children: [_jsx("div", { className: "w-4 h-4 rounded border border-gray-300", style: { backgroundColor: theme.backgroundColor } }), _jsx("div", { className: "w-4 h-4 rounded border border-gray-300", style: { backgroundColor: theme.textColor } })] }), _jsx("span", { className: "flex-1", children: theme.name }), isSelected && (_jsx("svg", { className: "w-4 h-4 text-interactive-emerald-flash", fill: "currentColor", viewBox: "0 0 20 20", children: _jsx("path", { fillRule: "evenodd", d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z", clipRule: "evenodd" }) }))] }));
};
/**
 * 文本阅读主题选择器组件
 */
export const TextReadingThemeSelector = ({ currentTheme, themes, onThemeChange, className = '', }) => {
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);
    const buttonRef = useRef(null);
    // 点击外部关闭下拉面板
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
            return () => document.removeEventListener('mousedown', handleClickOutside);
        }
        return undefined;
    }, [isOpen]);
    // ESC键关闭下拉面板
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setIsOpen(false);
                buttonRef.current?.focus();
            }
        };
        if (isOpen) {
            document.addEventListener('keydown', handleKeyDown);
            return () => document.removeEventListener('keydown', handleKeyDown);
        }
        return undefined;
    }, [isOpen]);
    const handleThemeSelect = (theme) => {
        onThemeChange(theme);
        setIsOpen(false);
        buttonRef.current?.focus();
    };
    const toggleDropdown = () => {
        setIsOpen(!isOpen);
    };
    return (_jsxs("div", { ref: containerRef, className: `relative ${className}`, children: [_jsxs("button", { ref: buttonRef, type: "button", className: "px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded transition-colors flex items-center gap-2", onClick: toggleDropdown, "aria-label": "Select Reading Theme", "aria-expanded": isOpen, "aria-haspopup": "listbox", children: [_jsxs("div", { className: "flex gap-0.5", children: [_jsx("div", { className: "w-3 h-3 rounded border border-gray-400", style: { backgroundColor: currentTheme.backgroundColor } }), _jsx("div", { className: "w-3 h-3 rounded border border-gray-400", style: { backgroundColor: currentTheme.textColor } })] }), _jsx("svg", { className: `w-3 h-3 transition-transform ${isOpen ? 'rotate-180' : ''}`, fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M19 9l-7 7-7-7" }) })] }), isOpen && (_jsx("div", { className: "absolute top-full right-0 mt-1 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50", children: _jsxs("div", { className: "p-2", children: [_jsx("div", { className: "text-xs font-medium text-gray-500 mb-2 px-2", children: "Select Reading Theme" }), _jsx("div", { role: "listbox", "aria-label": "Theme Options", children: themes.map(theme => (_jsx(ThemeItem, { theme: theme, isSelected: theme.id === currentTheme.id, onClick: handleThemeSelect }, theme.id))) })] }) }))] }));
};
export default TextReadingThemeSelector;
//# sourceMappingURL=TextReadingThemeSelector.js.map